(function () {
    'use strict';

    angular.module("imApp").factory("baseCurrenciesService", ['$ihttp', function ($ihttp) {
        let service = {
            listBaseCurrencies: function (parms) {
                return $ihttp.post({
                    method: 1017,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
